var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStatusDenied(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "95F7A09F-6B31-4FBB-BF41-B8A76BEF4D3E") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "21.2437619%",
    x2: "50%",
    y2: "95.931856%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005090",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0277BD",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-2",
    x: 0,
    y: 0,
    width: 1440,
    height: 1052
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: 0,
    width: 428,
    height: 604,
    rx: 4
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-5.6%",
    y: "-4.0%",
    width: "111.2%",
    height: "107.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.11 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Login",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Login-ERROR",
    transform: "translate(-520.000000, -733.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#F3F6FB",
    x: 0,
    y: 0,
    width: 1440,
    height: 1052
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#01579B",
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "background/login",
    transform: "translate(-3.000000, 0.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(501.000000, 159.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B71C1C",
    opacity: 0.291038876,
    x: 0,
    y: 562,
    width: 428,
    height: 42
  }), /*#__PURE__*/React.createElement("g", {
    id: "ic/status/error",
    transform: "translate(19.000000, 574.000000)",
    fill: "#B71C1C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.2,0 C14.2810197,0 18.4,4.1189803 18.4,9.2 C18.4,14.2810197 14.2810197,18.4 9.2,18.4 C4.1189803,18.4 0,14.2810197 0,9.2 C0,4.1189803 4.1189803,0 9.2,0 Z M12.4526912,4.64623233 L9.2,7.89892352 L5.94730881,4.64623233 L4.64623233,5.94730881 L7.89892352,9.2 L4.64623233,12.4526912 L5.94730881,13.7537677 L9.2,10.4996623 L12.4526912,13.7537677 L13.7537677,12.4526912 L10.5003694,9.19929289 L13.7537677,5.94730881 L12.4526912,4.64623233 Z",
    id: "Combined-Shape"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusDenied);
export default __webpack_public_path__ + "static/media/status-denied.7aa8ec46030d4b0af60b8757bc325749.svg";
export { ForwardRef as ReactComponent };